import create from "zustand";
import { persist, devtools } from "zustand/middleware";

let store = (set) => ({
  isLoggedIn: true,
  user: null,
  login: (user) =>
    set((state) => ({
      isLoggedIn: true,
      user: user,
    })),
  logout: () => set((state) => ({ isLoggedIn: false, user: null })),
});

store = persist(store, { name: "pocket_play_settings" });
store = devtools(store);

const useStore = create(store);

export default useStore;
